import { useState, useEffect } from 'react';
import { Player } from './types';

interface PlayerTimerProps {
    player: Player;
    isPlayerTurn: boolean;
}

function PlayerTimer({ player, isPlayerTurn }: PlayerTimerProps) {
    const [timeLeft, setTimeLeft] = useState<number>(player.timeLeft);

    useEffect(() => {
        setTimeLeft(player.timeLeft);
    }, [player.timeLeft]);

    useEffect(() => {
        let timer: ReturnType<typeof setInterval> | undefined;
        if (isPlayerTurn) {
            timer = setInterval(() => {
                setTimeLeft((prevTime) => {
                    if (prevTime <= 1000) {
                        if (timer) clearInterval(timer);
                        return 0;
                    }
                    return prevTime - 1000;
                });
            }, 1000);
        }

        return () => {
            if (timer) clearInterval(timer);
        };
    }, [isPlayerTurn]);

    const formatTime = (milliseconds: number): string => {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const minutes = Math.floor(totalSeconds / 60);
        const seconds = totalSeconds % 60;
        return `${minutes}:${seconds.toString().padStart(2, '0')}`;
    };

    return <span>{formatTime(timeLeft)}</span>;
}

export default PlayerTimer;
